import { React, useState } from "react";
import {
  Modal,
  Box,
  Stack,
  Button,
  IconButton,
  Typography,
  Alert,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import iconTrash from "../../../images/iconTrash.svg";
import "./styles.css";
import { ReactComponent as IconDiamond } from "../../../images/icon-diamond.svg";
import api from "../../../services/api";
import { FieldAutocomplete } from "../../../components/Fields";
import ModalDialogs from "../../../components/ModalDialogs";
import { ReactComponent as IconWallet } from "../../../images/iconWallet.svg";

const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 744,
    width: "90%",
    bgcolor: "background.paper",
    borderRadius: "4px",
    boxShadow: 24,
  },
  modalHeader: {
    backgroundColor: "#1E729F !important",
    padding: "10px 15px 10px 15px",
    color: "#FFFFFF",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alingItens: "center",
    paddingBottom: "20px",
    paddingTop: "20px",
    borderRadius: "4px",
  },
  title: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#063F5E",
  },
  autoComplete: {
    border: "1px solid #1E729F",
    borderRadius: 10,
  },
};

export function ModalAcessoProfissional({
  openModal,
  setOpenModal,
  edit = false,
  reativar = false,
  modalHeaderText = "",
  dados = null,
  setRefresh,
  refresh,
  profissionaisAdicionados,
  setProfissionaisAdicionados,
}) {
  const [profissional, setProfissional] = useState("");
  const [profissionaisList, setProfissionaisList] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  async function clearAll() {
    setOpenModal(false);
    setOpenDeleteModal(false);
    setProfissionaisList([]);
    setProfissional("");
  }

  const handleOpenDeleteModal = (profissional) => {
    setProfissional(profissional);
    setOpenDeleteModal(true);
  };

  function excluirProfissional(profissional) {
    const profissionaisMantidos = profissionaisAdicionados.filter(
      (item) => item.idVinculo !== profissional.idVinculo
    );
    setProfissionaisAdicionados(profissionaisMantidos);
    clearAll();
  }

  async function handleBuscarProfissional(value) {
    try {
      if (value === "") return setProfissionaisList([]);

      if (value.includes(" - ")) {
        value = value.split(" - ")[0];
      }

      if (value.length < 3) return setProfissionaisList([]);

      const response = await api.get(`/profissionais/${value}`);

      setProfissionaisList(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function handleSubmit() {
    try {
      if (!profissional)
        return alert("Os campos marcados com * são obrigatórios");

      const profissionalJaFoiAdicionado = profissionaisAdicionados.find(
        (item) => item.idUsuario === profissional.idUsuario
      );

      if (profissionalJaFoiAdicionado) {
        return alert("Profissional já adicionado");
      }

      setProfissionaisAdicionados([...profissionaisAdicionados, profissional]);
      clearAll();
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  return (
    <>
      <>
        {profissionaisAdicionados.map((profissional) => (
          <div className="frame-externo-estabelecimento">
            <div>
              <p className="fonte-frame-estabelecimento">Profissionais</p>
            </div>

            <div className="divisao-frame-interno" />

            <div className="frame-interno-estabelecimento">
              <div className="frame-interno-profissional">
                <div className="fonte-nome-profissional">
                  <p>{profissional.nome}</p>
                  <p> /CRM:</p>
                  <p>
                    {profissional.numeroConselho} - {profissional.ufConselho}
                  </p>
                </div>

                <div className="fonte-conselho-profissional">
                  <p>Cargo: {profissional.perfil}</p>
                  <p>CNS: {profissional.cns}</p>
                  <p>Estabelecimento: {profissional.estabelecimento}</p>
                </div>
              </div>

              <Button
                startIcon={
                  <img
                    className="filtro-vermelho"
                    src={iconTrash}
                    alt="Icone Lixo de Exclusão de Acesso de Estabelecimento"
                    width="100%"
                  />
                }
                size="small"
                variant="outlined"
                color="error"
                onClick={() => handleOpenDeleteModal(profissional)}
              >
                Excluir
              </Button>
            </div>
          </div>
        ))}

        <button
          style={{ cursor: "pointer" }}
          className="botao-adicionar"
          onClick={() => setOpenModal(true)}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.5 12.75H18.5"
              stroke="#1E729F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 18.75V6.75"
              stroke="#1E729F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="texto-botao">Adicionar profissional</p>
        </button>
        <>
          <Modal
            open={openModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            onClose={() => clearAll()}
          >
            <Box sx={styles.modal}>
              <Box sx={styles.modalHeader}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                >
                  <Typography sx={{ fontSize: "1.3rem" }}>
                    {modalHeaderText}
                  </Typography>
                  <IconButton>
                    <CloseOutlined
                      onClick={() => setOpenModal(false)}
                      sx={{ color: "white" }}
                    />
                  </IconButton>
                </Stack>
              </Box>

              <Box sx={{ padding: 3, borderRadius: "4px" }}>
                <Stack direction={"column"} spacing={2}>
                  <Alert icon={false} severity="info">
                    <Box
                      sx={{
                        display: "flex",
                        maxHeight: "24px",
                        alignItems: "center",
                        bgcolor: "rgb(229, 246, 253) !important",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <Box
                        width="24px"
                        height="24px"
                        bgcolor="transparent !important"
                      >
                        <IconDiamond
                          width="24px"
                          height="24px"
                          fill="#FC8518"
                        />
                      </Box>

                      <span>
                        Este marcador indica campos de preenchimento obrigatório
                      </span>
                    </Box>
                  </Alert>

                  <FieldAutocomplete
                    label="Nome"
                    getOptionLabel={(option) =>
                      `${option.nome} - ${option.perfil} - ${option.nomeConselho} - ${option.numeroConselho} - ${option.estabelecimento}` ||
                      ""
                    }
                    options={profissionaisList}
                    onInputChange={(event, value) =>
                      handleBuscarProfissional(value)
                    }
                    value={
                      profissionaisList
                        ? profissionaisList.find(
                            (option) => option.nome === profissional?.nome
                          )
                        : ""
                    }
                    setValue={(event, value) => setProfissional(value)}
                    required
                  />
                </Stack>
                <Stack direction="column" spacing={2} sx={{ mt: 5 }}>
                  <Box>
                    <Stack direction={"row"} justifyContent={"end"} gap={1}>
                      <Button
                        variant="outlined"
                        onClick={() => setOpenModal(false)}
                        sx={{
                          color: "#1E729F !important",
                          border: "1px solid #1E729F",
                        }}
                      >
                        {" "}
                        Cancelar{" "}
                      </Button>

                      <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{ bgcolor: "#1E729F !important" }}
                      >
                        {" "}
                        Salvar{" "}
                      </Button>
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            </Box>
          </Modal>
          <ModalDialogs
            open={openDeleteModal}
            onClose={() => clearAll()}
            onActionSecondary={() => clearAll()}
            onActionPrimary={() => excluirProfissional(profissional)}
            modalType="error"
            title={
              <>
                <IconWallet /> Excluir profissional
              </>
            }
            body={
              <Box>
                Você realmente deseja excluir o profissional? <br />
                <Typography
                  variant="body1"
                  mt={1}
                  fontSize={18}
                  textAlign={"left"}
                >
                  {profissional.nome} / CRM: {profissional.numeroConselho} -
                  {profissional.ufConselho} <br />
                  CNS: {profissional.cns}
                </Typography>
              </Box>
            }
            secondaryButtonText="Não"
            primaryButtonText="Sim"
          />
        </>
      </>

      <div></div>
    </>
  );
}
